module.exports = __webpack_public_path__ + "static/pic_videoEasy-62de1bd08992318598acb0dafd3f9b30.jpg";